<div class="cohort-header">

  @if (profile && [1, 2, 4].includes(profile.role_id)) {
    <mat-form-field class="search" actions appearance="outline" [formGroup]="form" style="margin-top: 1rem;">
      <mat-label>Search</mat-label>
      <input matInput type="text" formControlName="search">
      <button matSuffix mat-icon-button [disabled]="form.invalid" (click)="clearSearch()">
        <mat-icon *ngIf="form.invalid">search</mat-icon>
        <mat-icon *ngIf="form.valid">close</mat-icon>
      </button>
    </mat-form-field>
  }

  <div class="create-cohort" actions>
    <lib-button (click)="createCohortModal()">Create Cohort</lib-button>
  </div>
</div>

<div>
  <div *ngFor="let cohort of filteredCohorts" class="cohort-container">
    <lib-container class="cohort-container-inner">
      <div (click)="toggleCohort(cohort)" class="cohort-toggle">
        <span class="cohort-toggle-symbol">
          {{ cohort.isExpanded ? '-' : '+' }}
        </span>
        <span>{{ cohort.name }}</span>
      </div>
      
      <div *ngIf="cohort.isExpanded">
        <lib-content-loader *ngIf="loading"></lib-content-loader>
        
        <table *ngIf="!loading" mat-table [dataSource]="cohort.users">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="cohort-table-header">Name</th>
            <td mat-cell *matCellDef="let ref" class="cohort-table-cell">{{ ref.first_name + ' ' + ref.last_name }}</td>
          </ng-container>
        
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef class="cohort-table-header">Email</th>
            <td mat-cell *matCellDef="let ref" class="cohort-table-cell">{{ ref.email_address }}</td>
          </ng-container>
        
          <ng-container matColumnDef="org">
            <th mat-header-cell *matHeaderCellDef class="cohort-table-header">Org</th>
            <td mat-cell *matCellDef="let ref" class="cohort-table-cell">{{ cohort.org_name }}</td>
          </ng-container>
        
          <ng-container matColumnDef="remove">
            <th mat-header-cell *matHeaderCellDef class="cohort-table-actions-header">
              <lib-button mat-button (click)="addUserModal(cohort.id)">Add User</lib-button>
            </th>
            <td mat-cell *matCellDef="let ref" class="cohort-table-actions-cell">
              <lib-button mat-button color="accent" (click)="remove(cohort.id, ref.id)">Remove</lib-button>
            </td>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="columns"></tr>
          <tr mat-row *matRowDef="let row; columns: columns;"></tr>
        </table>
        
        <div *ngIf="cohort.users.length === 0 && !loading">
          <p>No current users found</p>
        </div>
      </div>
    </lib-container>
  </div>
</div>
